import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { ROUTES } from '@/lib/routes';

type Props = { open: boolean; onOpenChange: (v: boolean) => void };

const SHORTCUTS: Array<{ keys: string; label: string }> = [
  { keys: '⌘K / Ctrl+K', label: 'Open command palette' },
  { keys: '?', label: 'Show this shortcuts panel' },
  { keys: 'Esc', label: 'Close current overlay' },
  ...ROUTES.map((r) => ({
    keys: `g ${r.chord}`,
    label: `Go to ${r.label}`,
  })),
];

export function ShortcutsHelp({ open, onOpenChange }: Props) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-zinc-950/80 backdrop-blur-sm z-50 data-[state=open]:animate-in data-[state=open]:fade-in" />
        <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md rounded-xl border border-zinc-800 bg-zinc-950 shadow-2xl p-5 data-[state=open]:animate-in data-[state=open]:fade-in data-[state=open]:zoom-in-95">
          <div className="flex items-center justify-between mb-4">
            <Dialog.Title className="text-sm font-semibold text-zinc-100">
              Keyboard shortcuts
            </Dialog.Title>
            <Dialog.Close
              className="text-zinc-400 hover:text-zinc-200 p-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
              aria-label="Close shortcuts"
            >
              <X className="size-4" />
            </Dialog.Close>
          </div>
          <ul className="space-y-1.5">
            {SHORTCUTS.map((s) => (
              <li key={s.keys} className="flex items-center justify-between gap-3 py-1.5">
                <span className="text-sm text-zinc-300">{s.label}</span>
                <kbd className="font-mono text-[11px] px-1.5 py-0.5 rounded border border-zinc-800 bg-zinc-900 text-zinc-400">
                  {s.keys}
                </kbd>
              </li>
            ))}
          </ul>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
